const API_END_POINTS = {
    LOGIN: '/login',
    BOOKINGS: '/bookings',
    OFFSET: '?offset=',
    LIMIT: '&limit=',
    SEARCH_TERM: '&searchTerm=',
};

export { API_END_POINTS };
